module.exports = __webpack_public_path__ + "img/adobe.59ba6f20.webp";